module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve3"
    }
  }, [_vm._v("Tourette’s of the Heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve4"
    }
  }, [_vm._v("Swisher Sweets")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve5"
    }
  }, [_vm._v("Sweet Nothings")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve6"
    }
  }, [_vm._v("The House of Naan and Saffron")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve7"
    }
  }, [_vm._v("The Franklin Avenue Rookery for Wayward Babies")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve8"
    }
  }, [_vm._v("The Little Ice Girl")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve9"
    }
  }, [_vm._v("Good as Biscotti")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve10"
    }
  }, [_vm._v("Pink Flamingos and the Good Friday Massacres")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve11"
    }
  }, [_vm._v("Silver")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve12"
    }
  }, [_vm._v("The Color of Fisticuffs and Bloodlines")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve13"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/FranklinAve14"
    }
  }, [_vm._v("Acknowledgments")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59081b0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FranklinAve-2.vue
// module id = 66
// module chunks = 0